import RenderManager from "../rendering/render-manager";
import Network from "../miniviews/network";

function isVisible(object) {
    let visible = object.visible, parent = object;

    while ((parent && parent !== RenderManager.activeScene && Network.insideCurrentWorld(parent)) && visible) {
        parent = parent.parent;
        visible = !parent || visible && parent.visible;
    }

    return visible;
}

export default isVisible;
export { isVisible };